import gsap from 'gsap';

// Constant-speed GSAP strip tween, shared by page opt-ins.
export default function animateStripTrack(track: HTMLElement, reverse = false, duration = 16) {
    const tween = gsap.fromTo(track, { xPercent: reverse ? -50.2 : 0 }, {
        xPercent: reverse ? 0 : -50.2,
        duration: duration * 4,
        repeat: -1,
        ease: 'none',
    });
    return {
        pause: () => { tween.pause(); },
        play: () => { tween.play(); },
        kill: () => { tween.kill(); },
    };
}
